module.exports = __webpack_public_path__ + "static/media/Menu-dimsum-BG.6432f7f6.jpg";